export default {
  computed:{
    computedStyle(){
      return this.styleComputor()
    }
  },
  data(){
    return {
      appHeight:0
    }
  },
  created(){
    this.$bus.on('nav-resize',res=>{
      let {h} = res;
      this.appHeight = h;
    })
  }
}